<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-form @submit.prevent="onSubmit">
            <v-row>
                <v-col cols="12" md="12">
                    <ValidationProvider rules="required" v-slot="v">
                        <v-autocomplete v-model="selectedItem" dense chips deletable-chips :error-messages="v.errors[0]"
                            :items="resumenAportes" label="Seleccionar resumen" return-object item-value
                            :item-text="item => `${item.destipapo}`" color="primary"></v-autocomplete>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12">
                    <v-btn type="onSubmit" block class="pa-5" :disabled="invalid" elevation="0" color="primary">
                        <v-icon class="mr-3">fa-file-pdf</v-icon>
                        Imprimir detalle de aportes
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </ValidationObserver>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            selectedItem: [],

        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('boletas', ['imprimirPdf']),


        onSubmit() {
            this.$refs.observer.validate().then(result => {
                if (result) {
                    const data = {
                        url: process.env.VUE_APP_APORTES,
                        nroafi: this.nroafi,
                        tapid: this.selectedItem.tipapo,
                        da: ''
                    }

                    this.imprimirPdf(data)
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            });
        },
        ver() {
            console.log(this.selectedItem)
        }

    },
    computed: {
        ...mapGetters('boletas', ['resumenAportes']),
        ...mapGetters('auth', ['nroafi'])
    }
};
</script>